import React from "react";
import { isDarkColor, toRgbString, getOpacity } from "../lib/colorMath";

class DabSVG extends React.Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
  }

  componentDidMountXXX() {
    console.log("Dab did mount");
    if (this.props.final) {
      console.log("final", this.props);
    }

    let color = this.props.color;
    let illegalColor = false;
    if (
      !this.props.color ||
      typeof this.props.color !== "object" ||
      !("r" in this.props.color)
    ) {
      color = { r: 128, g: 128, b: 128, a: 0.3 };
      illegalColor = true;
    }

    //     const opacity = "a" in this.props.color ? this.props.color.a * 255 : 255;
    const opacity = "a" in color ? color.a * 255 : 255;
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext("2d");
    const self = this;

    const img = new Image(); // Create new img element
    img.addEventListener(
      "load",
      function () {
        // execute drawImage statements here
        const dabWidth = self.props.dab.width; //600;
        const dabHeight = self.props.dab.height; //200;

        ctx.drawImage(img, 0, 0, dabWidth, dabHeight);
        console.log(self.props);

        const imgData = ctx.getImageData(0, 0, dabWidth, dabHeight);
        const data = imgData.data;
        for (let y = 0; y < dabHeight; y++) {
          for (let x = 0; x < dabWidth; x++) {
            let base = (y * dabWidth + x) * 4;
            if (data[base + 3] > 50) {
              if (illegalColor) {
                if ((x + y) % 32 > 16) {
                  data[base] = color.r;
                  data[base + 1] = color.g;
                  data[base + 2] = color.b;
                  data[base + 3] = opacity;
                } else {
                  data[base] = 255;
                  data[base + 1] = 255;
                  data[base + 2] = 255;
                  data[base + 3] = opacity;
                }
              } else {
                data[base] = color.r;
                data[base + 1] = color.g;
                data[base + 2] = color.b;
                data[base + 3] = opacity;
              }
            } else {
              data[base + 3] = 0;
            }
          }
        }
        ctx.putImageData(imgData, 0, 0);
      },
      false
    );
    //    img.src = "PNG.png"; // Set source path
    img.src = this.props.dab.img; // "11.png"; // Set source path
  }

  componentWillUnmount() {
    console.log("Dub will unmount");
  }

  render() {
    let { dab, color } = this.props;
    const textColor = isDarkColor(color) ? "white" : "black";

    let illegalColor = false;
    let opacity = 1;
    if (
      !this.props.color ||
      typeof this.props.color !== "object" ||
      !("r" in this.props.color)
    ) {
      color = { r: 128, g: 128, b: 128, a: 0.3 };
      illegalColor = true;
    } else {
      opacity = getOpacity(color);
    }
    let colorOpaque = toRgbString(color);
    console.log("color", color);

    const span =
      dab?.textLeft && dab?.textTop ? (
        <span
          style={{
            marginLeft: dab?.textLeft,
            marginTop: dab?.textTop,
            position: "absolute",
            color: textColor,
            fontSize: 18,
          }}
        >
          {this.props.text}
        </span>
      ) : (
        ""
      );
    return (
      <div
        className={this.props.final ? "final-dab" : "dab"}
        style={{
          background: this.props.color,
          top: dab.top, //offset,
          width: "100%",
          /*top: this.props.offset / 2,*/
        }}
      >
        {this.props.final ? (
          <span
            className="final-color"
            style={{
              color: textColor,
            }}
          >
            {this.props.text}
          </span>
        ) : (
          <React.Fragment>
            {illegalColor ? (
              <svg
                style={{
                  stroke: "grey",
                  strokeDasharray: "5,5",
                  fill: "none",
                  marginLeft: dab.left, //offset,
                  width: this.props.dab.width,
                }}
              >
                <use href={this.props.dab.img}></use>
              </svg>
            ) : (
              <svg
                className={this.props.dab.className}
                style={{
                  stroke: color,
                  fill: colorOpaque,
                  fillOpacity: opacity,
                }}
              >
                <use href={this.props.dab.img}></use>
              </svg>
            )}
            {span}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default DabSVG;
